export default "__VITE_ASSET__0ca379bb__"